import Cookies from 'cookies-js'
import { CookieStorage } from 'redux-persist-cookie-storage'
import { combineReducers } from 'redux'
import { persistReducer, createTransform } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import CryptoJS from 'crypto-js'

import consumptionMap from './consumptionMap'
import controlledProducts from './controlledProducts'
import controlledProductReport from './controlledProductReport'
import headers from './headers'
import license from './license'
import menu from './menu'
import productMap from './productMap'
import search from './search'
import auth from './auth'
import authResponse from './authResponse'
import incompatibilityAnalysis from './incompatibilityAnalysis'
import area from './area'
import overview from './overview'
import inventory from './inventory'
import report from './report'
import cabinetProducts from './cabinetProducts'
import fispqs from './fispqs'
import news from './news'
import certificateControl from './certificateControl'
import measure from './measure'

const { REACT_APP_ENCRYPT_SECRET_KEY } = process.env

const encrypt = createTransform(
  (inboundState, key) => {
    if (!inboundState) return inboundState

    const cryptedText = CryptoJS.AES.encrypt(JSON.stringify(inboundState), REACT_APP_ENCRYPT_SECRET_KEY)

    return cryptedText.toString()
  },
  (outboundState, key) => {
    if (!outboundState) return outboundState

    const bytes = CryptoJS.AES.decrypt(outboundState, REACT_APP_ENCRYPT_SECRET_KEY)
    const decrypted = bytes.toString(CryptoJS.enc.Utf8)

    return JSON.parse(decrypted)
  }
)

const persistHeadersConfig = {
  key: 'EXO_GPQ',
  storage: new CookieStorage(Cookies, {
    expiration: {
      default: 0 // session
    }
  }),
  whitelist: [
    'tokenType',
    'accessToken',
    'client',
    'expiry',
    'uid'
  ],
  transforms: [encrypt]
}

const persistConfig = {
  key: 'EXO_GPQ',
  storage,
  blacklist: [
    'tokenType',
    'accessToken',
    'client',
    'expiry',
    'uid'
  ]
}

export default combineReducers({
  headers: persistReducer(persistHeadersConfig, headers),
  auth: persistReducer(persistConfig, auth),
  authResponse,
  consumptionMap,
  controlledProducts,
  controlledProductReport,
  license,
  menu,
  productMap,
  search,
  area,
  incompatibilityAnalysis,
  overview,
  inventory,
  report,
  cabinetProducts,
  fispqs,
  news,
  certificateControl,
  measure
});



// WEBPACK FOOTER //
// ./src/reducers/index.js